const RANKING_ITEMS = [
  { id: 1, rank: 1, title: '91年国产经典影片《岁月》', type: '电影', views: '128.5万', trend: 'up' },
  { id: 2, rank: 2, title: '国产电视剧《都市情缘》全集', type: '电视剧', views: '106.2万', trend: 'up' },
  { id: 3, rank: 3, title: '热门国产综艺《欢乐星期六》', type: '综艺', views: '98.7万', trend: 'up' },
  { id: 4, rank: 4, title: '国产高分纪录片《山河》', type: '纪录片', views: '85.3万', trend: 'stable' },
  { id: 5, rank: 5, title: '91年国产喜剧《笑林》回顾', type: '电影', views: '72.1万', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热播排行</h2>
          <p className="text-sm md:text-base text-foreground-500">91国产视频本周播放量排行榜</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {RANKING_ITEMS.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 p-4 rounded-xl cursor-pointer transition-colors hover:bg-background-50 ${
                idx < RANKING_ITEMS.length - 1 ? 'mb-2' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-black flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-400/80 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-300/80 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-semibold text-foreground-800 truncate">{item.title}</div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs px-2 py-0.5 rounded bg-primary-100 text-primary-600 font-medium whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-sm font-bold text-foreground-700 whitespace-nowrap">{item.views}</div>
                <div className="flex items-center justify-end gap-1 mt-0.5">
                  <i className={`text-xs ${
                    item.trend === 'up' ? 'ri-arrow-up-line text-accent-500' : 'ri-subtract-line text-foreground-400'
                  }`}></i>
                  <span className="text-xs text-foreground-400">播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}